import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';
@Injectable()
export class CandlestickConditionDefaultService {
    constructor(private http: HttpRequestService) {
    }

    getConditions(dataRequest: any) {
        return this.http.get('candlestick-condition-default/conditions' + this.parseParamToString(dataRequest))
            .map(res => {
                return res.json();
            });
    }

    save(model) {
        return this.http.put('candlestick-condition-default', model).map(res => {
            return res.json();
        });
    }

    parseParamToString(param: any) {
        let queryString = `?`;
        for (var property in param) {
            if (param.hasOwnProperty(property)) {
                queryString += `&${property}=${param[property]}`;
            }
        }
        return queryString;
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/candlestick-condition-default.service.ts